if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
             jQuery.getJSON('/cart.js', function(cart) { 
  var gwpVariantElement = document.querySelector('.gwp_variant');
  
  // Check if the .gwp_variant element exists
  if (!gwpVariantElement) {
    console.error('Error: .gwp_variant element not found.');
    return; // Stop execution if the element is missing
  }

  var gwpVariantId = parseInt(gwpVariantElement.getAttribute('gwp_variant_id'));
  var gwpThreshold = parseInt(gwpVariantElement.getAttribute('gwp_threshold_price'));
  
  var total_non_gift_card_price = 0;
  var isGiftCardInCart = false;
  var isOtherProductInCart = false;
  var freeProductInCart = false;
  var gwpLineId = null;

  cart.items.forEach(function(item, index) {
    // Check if the free product (GWP) is already in the cart
    if (item.id === gwpVariantId) {
      freeProductInCart = true;
      gwpLineId = item.key; // Use the unique key instead of the index for precise targeting
    }

    // Check if a gift card is in the cart
    if (item.handle === 'smallflower-gift-card') {
      isGiftCardInCart = true;
    }

    // Check if there is any other product (non-gift card and non-GWP) in the cart
    if (item.id !== gwpVariantId && item.handle !== 'smallflower-gift-card') {
      isOtherProductInCart = true;
      total_non_gift_card_price += item.line_price / 100; // Calculate total price excluding gift card and GWP
    }
  });

  console.log(gwpVariantId);
  console.log(isGiftCardInCart);
  console.log(isOtherProductInCart);
  console.log(freeProductInCart);
  console.log(total_non_gift_card_price);

  // If total non-gift-card price exceeds threshold, GWP is not in the cart, and there is at least one other qualifying product (non-gift card)
  if (total_non_gift_card_price >= gwpThreshold && !freeProductInCart && isOtherProductInCart) {
    let formData = {
      'items': [{
        'id': gwpVariantId,
        'quantity': 1
      }]
    };

    // Add the free product (GWP)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      // Update the cart drawer or cart items if necessary
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems) {
        cartItems.updateQuantity(1, 1);
      }
    });
    console.log(gwpVariantId);
  }
  // If total non-gift-card price is below threshold or no qualifying products are in the cart, and GWP is in the cart, remove the free product
  else if ((total_non_gift_card_price < gwpThreshold || !isOtherProductInCart) && freeProductInCart) {
    let formData = {
      'line': gwpLineId,  // Use the unique key to target the exact line of the GWP
      'quantity': 0
    };

    // Remove the free product (GWP) only
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => {
      // Update the cart drawer or cart items if necessary
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems) {
        cartItems.updateQuantity(1, 0);
      }
    });
    console.log(gwpVariantId);
  }
});
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
